import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=1f07c39c&"
import script from "./ProjectNotes.vue?vue&type=script&lang=js&"
export * from "./ProjectNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports